import React, { useEffect, useState } from "react";
import userService from "../../../app/services/user.service";
import { useSearchParams } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../../assets/img/motion_new_logo.png";
import footer from "../../../assets/img/footer_icon.jpg";
import omr1 from "../../../assets/img/Instruction_omr_1_main_jee.jpg";
import omr2 from "../../../assets/img/Instruction_omr_2_adv_jee.jpg";
import backImage from "../../../assets/img/back_page_ncert.jpg";
import styles from "./GeneratePaper.module.css";
import Loader from "../../../UI/loader/loader";
import { isEmpty } from "../../../utils/custom_funtions";
import { uid } from "react-uid";
import useMathjax from "../../../hooks/useMathjax";
import { Button } from "react-bootstrap";
import footerImage from "../../../assets/img/footer1.jpg"


const GeneratePaper = () => {
  const [searchParams] = useSearchParams();
  const [info, setInfo] = useState({});
  const [subjectArr, setSubjectArr] = useState([]);
  const [sectionArr, setSectionArr] = useState([]);
  // const [facultyArr, setFacultyArr] = useState([]);
  const [quesData, setQuesData] = useState([]);
  const [foramtData, setForamtData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [syllabusArr, setSyllabusArr] = useState([]);
  useMathjax(quesData);

  const optionLabels = ["A", "B", "C", "D"];

  const parseOptionString = (raw = "") => {
    if (!raw) return [];
    if (raw.includes("@@@")) {
      return raw.split("@@@").filter(Boolean);
    }
    return raw.split("@").filter(Boolean);
  };

  const buildOptions = (question, language = "english") => {
    const rawOptions =
      language === "english" ? parseOptionString(question.eng_option) : parseOptionString(question.h_option);

    const fallbackOptions =
      language === "english"
        ? [question.option_a, question.option_b, question.option_c, question.option_d]
        : [question.option_a_hindi, question.option_b_hindi, question.option_c_hindi, question.option_d_hindi];

    return optionLabels
      .map((label, idx) => ({
        label,
        value: rawOptions[idx] ?? fallbackOptions[idx] ?? "",
      }))
      .filter((option) => option.value);
  };

  const getOptionLayoutClass = (question) => {
    const hint =
      question.optionLayout ||
      question.option_layout ||
      question.optionColumns ||
      question.option_columns;

    const normalized =
      typeof hint === "string"
        ? hint.toLowerCase()
        : hint;

    if (normalized === 4 || normalized === "4" || normalized === "four" || normalized === "all") {
      return "option-cols-4";
    }

    if (normalized === 2 || normalized === "2" || normalized === "two" || normalized === "double") {
      return "option-cols-2";
    }

    return "option-cols-1";
  };

  const renderOptions = (question, language = "english") => {
    const options = buildOptions(question, language);
    if (!options.length) {
      return null;
    }

    const optionLayoutClass = getOptionLayoutClass(question);
    const baseKey = question.matrix_id || question.qid || question.id;

    return (
      <div
        className={`option-grid ${optionLayoutClass}`}
        data-option-layout={optionLayoutClass}
        style={{
          margin: '0 !important',
          padding: '0 !important',
          lineHeight: '1 !important',
          position: 'relative',
          top: '-6px',
          display: 'block',
          width: '100%',
          border: 'none !important',
          outline: 'none !important',
          fontFamily: 'Verdana, Geneva, Tahoma, sans-serif'
        }}
      >
        {options.map((option, idx) => (
          <div key={`${baseKey || idx}-${option.label}`} className="option-item">
            <span className="option-item-label">({option.label})</span>
            <div
              className={`${styles.paperFontSize1} option-item-text`}
              dangerouslySetInnerHTML={{ __html: option.value }}
            />
          </div>
        ))}
      </div>
    );
  };


  const subjectWiseSeqMap = {};
  if (info.number_sequence == 3) {
    subjectArr.forEach((sub) => {
      const subjectQuestions = quesData.filter((q) => q.sub_id === sub.sub_id);
      subjectQuestions.forEach((q, i) => {
        subjectWiseSeqMap[q.matrix_id] = i + 1;
      });
    });
  }

  const setPrintPageSize = (size) => {
    let style = document.getElementById("dynamic-print-page-size");

    if (!style) {
      style = document.createElement("style");
      style.id = "dynamic-print-page-size";
      document.head.appendChild(style);
    }

    style.innerHTML = `
      @media print {
        @page {
          size: ${size};
           margin: 1rem !important;
           padding:1rem 0rem;
          
        }
           
      }
    `;
  };

  const getInstructionImageUrl = (url) => {
    if (!url) return "";

    const LIVE_BASE_URL = "https://quizmaster.motion.ac.in";
  
    // if image is coming from ckfinder folder (live)
    if (url.includes("ckfinder/userfiles")) {
      return `${LIVE_BASE_URL}${url}`;
    }
  
    // otherwise (local / CDN)
    return url;
  };

  useEffect(() => {
    // Bulk Question Request size
    setPrintPageSize("A4");

    return () => {
      // Cleanup when leaving page
      const style = document.getElementById("dynamic-print-page-size");
      if (style) style.remove();
    };
  }, []);


  const getPaperData = () => {
    setLoading(true);
    userService
      .getPaperInfo(searchParams.get("paperid"))
      .then((res) => {
        // console.log('infodata',res.data.data[0][0])
        const response = res.data.data;
        const datas = {
          ...response,
          // to_be_held_on: convertDate(res.data.data?.to_be_held_on),
        };
        document.title = `${datas.paperdetail.paper_name}_${datas.paperdetail.to_be_held_on}_${datas.paperdetail.center}`;
        setInfo(datas.paperdetail);
        // Parse syllabusArr from papersyllabus (now an object with numeric keys)
        setSyllabusArr(
          response.papersyllabus
            ? Object.values(response.papersyllabus)
            : []
        );
        console.log(datas);
        // setQuesData(Object.values(res.data.data[0]))
        userService.getFormatById(datas.paperdetail.paper_format_id)
          .then(res => {
            console.log('getFormatById', res.data.data.details)
            setForamtData(res.data.data.details)
          })
          .catch(err => {
            console.log(err)
          })
        userService
          .getPaperData(
            searchParams.get("paperid"),
            "'" + datas.sub_sequence + "'"
          )
          .then((res) => {
            // console.log(res);
            // console.log('getPaperData',Object.values(res.data.data[0]));
            const quesdatas = Object.values(res.data.data[0]);
            const subList = Array.from(new Set(quesdatas.map((x) => ({ subject: x.subject, sub_id: x.sub_id })).map(JSON.stringify))).map(JSON.parse)

            const sectionList = Array.from(new Set(quesdatas.map((x) => ({ section_name: x.section_name, sec_id: x.sec_id })).map(JSON.stringify))).map(JSON.parse)
            // console.log('quesData.find(x => x.display_number === null)',quesdatas.length)
            // console.log('quesData.find(x => x.display_number === null)',quesdatas.find(x => x.display_number === null))
            if (quesdatas.find(x => x.display_number === null)) {
              // const body1 = {paper_id: searchParams.get("paperid")}
              userService.resetDisplayNo({ paper_id: searchParams.get("paperid") })
                .then(res => {
                  // console.log("Resetting Display Number",res.data)
                  // After resetting the display number
                  // if(searchParams.get("key") == 0){
                  let bodyy = []
                  subList.map(sub => {
                    sectionList.map(sec => {
                      if (!isEmpty(quesdatas.filter(
                        (x) =>
                        (x.sub_id == sub.sub_id &&
                          x.sec_id == sec.sec_id)
                      ))) {
                        quesdatas.filter(
                          (x) =>
                          (x.sub_id == sub.sub_id &&
                            x.sec_id == sec.sec_id)
                        ).map((data, quesIndex) => {
                          bodyy.push({
                            "matrix_id": data.matrix_id,
                            "display_no": quesIndex + 1
                          })

                        })
                      }
                    })
                  })
                  console.log("bodyy", bodyy)
                  userService.regenerateDisplayNo(bodyy)
                    .then(res => {
                      console.log('regenerateDisplayNo', res)
                    })
                    .catch(err => {
                      console.error(err)
                    })

                  // }
                  // if(searchParams.get("key") == 1){}
                  // if(searchParams.get("key") == 2){}
                  // if(searchParams.get("key") == 3){}
                })
                .catch(err => {
                  console.log(err)
                })
            }

            console.log(subList)
            console.log(sectionList)
            setSectionArr(sectionList);
            setSubjectArr(subList);
            setQuesData(quesdatas);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    const key = searchParams.get("key");
    getPaperData();
    // getQuestionMapping()
  }, []);
  function convertDate(dateStr) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Split the input date string
    const parts = dateStr.split("-");

    // Extract year, month, and day
    const year = parts[0];
    const month = months[parseInt(parts[1], 10) - 1];
    const day = parts[2];

    // Combine them into the desired format
    const date = `${year}-${month}-${day}`;
    return date.split("-").reverse().join("-");
  }

  return (
    <>
      {/* <Button onClick={() => {
        console.log('foramtData', foramtData)
        console.log('quesData', quesData)
        console.log('sectionArr', sectionArr)
        console.log('subjectArr', subjectArr)
        console.log('info', info)
      }}>Console</Button> */}
      {loading ? (
        <Loader />
      ) : (
        <>


          {/* <button onClick={() => console.log(quesData)}>dvsv</button> */}
          <table style={{ width: "98%" }} className={`${styles.printable} print-page print-generate-paper`}>
            <tbody style={{ marginBottom: "80px" }}>
              <tr>
                <td>
                  <div className={styles.printContainer} style={{ width: '90%', margin: 'auto' }} paperFontSize>
                    <div className={styles.logoContainer} style={{ width: '80%', margin: 'auto', marginBottom: '8px' }}>
                      <img src={logo} />
                    </div>
                    <p className={`${styles.title} ${styles.title_width}`}>
                      Paper Code {`[CODE - ${info.paper_id}]`}
                    </p>
                    <p className={`${styles.title} ${styles.title_width}`}>{info.paper_name}</p>
                    <p className={`${styles.title} ${styles.title_width}`}>
                      {`${info.class} ${info.target} - ${info.phase} : ${info.center}`}
                      {info.batch_name && (
                        <p className={`${styles.title} ${styles.title_width}`}>{info.batch_name}</p>
                      )}
                    </p>
                    <div className={styles.paperDetail}>
                      <p className={styles.title}>Date: {new Date(info.to_be_held_on).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      }).replace(/ /g, '-')}</p>
                      <p className={styles.title}>Duration: {info.duration} </p>
                      <p className={styles.title}>
                        Max Marks:{" "}
                        {isEmpty(info.max_marks)
                          ? info.total_marks
                          : info.max_marks}
                      </p>
                    </div>
                    {!isEmpty(info.instructions_image) && (
                      <div className={styles.instruction}>
                        <img src={getInstructionImageUrl(info.instructions_image)} style={{ width: "100%" }} alt="instruction image" />

                      </div>
                    )}
                    {
                      info.target_id == 1 && (
                        <div className={styles.instruction1}>
                          <img src={omr1} style={{ width: "100%" }} alt="instruction image" />

                        </div>
                      )
                    }
                    {
                      info.target_id == 2 && (
                        <div className={styles.instruction1}>
                          <img src={omr2} style={{ width: "100%" }} alt="instruction image" />

                        </div>
                      )
                    }
                    {/* Syllabus Section (styled like screenshot, below instruction image) */}
                    {syllabusArr.length > 0 && (
                      <div className={styles.syllabusNoBreak} style={{
                        // border: '1px solid #999',
                        margin: '10px 0',
                        padding: '0',
                        background: '#fff'
                      }}>
                        <div style={{
                          // background: '#999',
                          color: '#222',
                          fontWeight: 'bold',
                          fontSize: '20px',
                          textAlign: 'center',
                          padding: '8px 0',
                          letterSpacing: '2px',
                          // borderTop:'2px solid black',
                          borderBottom: '1px solid rgb(59, 49, 49)'
                        }}
                          className={styles.syllabus}
                        >
                          SYLLABUS
                        </div>
                        {syllabusArr.map((syl, idx) => (
                          <React.Fragment key={syl.sub_id || idx}>
                            <div style={{
                              background: '#bdbdbd',
                              color: '#222',
                              fontWeight: 'bold',
                              fontSize: '18px',
                              textAlign: 'center',
                              padding: '6px 0',
                              marginTop: idx === 0 ? '20px' : '10px'
                            }}>
                              {syl.sub_name || `Subject ${idx + 1}`}
                            </div>
                            <div style={{
                              textAlign: 'left  ',
                              paddingLeft: '30px',
                              fontSize: '16px',
                              fontWeight: 500,
                              margin: '10px 0 20px 0'
                            }}>
                              {syl.topic_names || syl.topic_remarks}
                            </div>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    {searchParams.get("key") == 0 && (
                      <>
                        {subjectArr.map((sub) => (
                          <React.Fragment key={uid(sub)}>
                            {sectionArr.map((sec, secIndex) => {
                              const sec_inst_cond = !isEmpty(foramtData?.find(x => (x.section_id == sec.sec_id && x.sub_id == sub.sub_id))?.section_instruction)
                              const questions = quesData?.filter(
                                (x) => x.sub_id == sub.sub_id && x.sec_id == sec.sec_id
                              );
                              // Group questions by paragraph_id
                              const seqMap = {}; questions.forEach((q, i) => { seqMap[q.matrix_id] = i + 1; });
                              const grouped = {};
                              questions.forEach(q => {
                                const pid = q.paragraph_id || `no_para_${q.matrix_id}`;
                                if (!grouped[pid]) grouped[pid] = [];
                                grouped[pid].push(q);
                              });
                              return !isEmpty(questions) && (
                                <React.Fragment key={uid(sec)}>
                                  <div className={styles.tableTitle} style={{ pageBreakBefore: sec_inst_cond ? 'always' : "none", borderBottom: sec_inst_cond ? 'none' : "2px solid #000", marginBottom: sec_inst_cond ? "0" : "10px" }}>
                                    <span>
                                      {sub.subject?.toUpperCase()}
                                    </span>
                                  </div>
                                  <hr />
                                  {sec_inst_cond && (
                                    <div className={styles.instruction1}>
                                      <img src={getInstructionImageUrl(foramtData?.find(x => (x.section_id == sec.sec_id && x.sub_id == sub.sub_id))?.section_instruction)} style={{ width: "100%" }} alt={sub.subject + " " + sec.section_name} />
                                    </div>
                                  )}
                                  {Object.values(grouped).map((group, gidx) => (
                                    <React.Fragment key={gidx}>
                                      {(!isEmpty(group[0].p_text) || !isEmpty(group[0].m_p_text)) && (
                                        <div style={{ pageBreakInside: "avoid" }} className={`${styles.paperFontSize} row mb-3`}>
                                          <b className="col-12 mb-2">Passage:</b>

                                          {/* LEFT SIDE - ENGLISH PASSAGE */}
                                          <div className="col-xs-6 col-sm-6 col-md-6">
                                            <div dangerouslySetInnerHTML={{ __html: group[0].p_text || group[0].m_p_text }} className={`${styles.paperFontSize}`} />
                                          </div>

                                          {/* RIGHT SIDE - HINDI PASSAGE */}
                                          <div className="col-xs-6 col-sm-6 col-md-6">
                                            <div dangerouslySetInnerHTML={{ __html: group[0].p_text_hindi || group[0].m_p_text_hindi }} className={`${styles.paperFontSize}`} />
                                          </div>
                                        </div>
                                      )}
                                      {group.map((data, quesIndex) => (
                                        <div
                                          className={`row gx-4 mb-3`}
                                          style={{ pageBreakInside: "avoid" }}
                                          key={data.matrix_id}
                                        >
                                          <div className="col-xs-6 col-sm-6 col-md-6 pe-3">
                                            <div className="row">
                                              <div className="col-xs-1 col-sm-1 col-md-1 q-font">
                                                <p>
                                                  <strong>
                                                    {
                                                      info.number_sequence === 1
                                                        ? data.display_number
                                                        : info.number_sequence === 2
                                                          ? seqMap[data.matrix_id]
                                                          : info.number_sequence === 3
                                                            ? (subjectWiseSeqMap[data.matrix_id] ?? data.display_number)
                                                            : data.display_number
                                                    }.
                                                  </strong>
                                                </p>
                                              </div>

                                              <div className="col-xs-11 col-sm-11 col-md-11" >
                                                <div
                                                  dangerouslySetInnerHTML={{ __html: data.q_text }}
                                                  style={{
                                                    margin: '15px !important',
                                                    padding: '0px !important',
                                                    lineHeight: '1 !important',
                                                    display: 'block',
                                                    width: '100%',
                                                    marginBottom: '0 !important',
                                                    border: 'none !important',
                                                    outline: 'none !important'
                                                  }}
                                                  className={`${styles.paperFontSize}`}
                                                />
                                                {renderOptions(data, "english")}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-xs-6 col-sm-6 col-md-6 ps-3">
                                            <div className="row">
                                              <div className="col-xs-1 col-sm-1 col-md-1 q-font">
                                                <p>
                                                  <strong>
                                                    {
                                                      info.number_sequence === 1
                                                        ? data.display_number
                                                        : info.number_sequence === 2
                                                          ? seqMap[data.matrix_id]
                                                          : info.number_sequence === 3
                                                            ? (subjectWiseSeqMap[data.matrix_id] ?? data.display_number)
                                                            : data.display_number
                                                    }.
                                                  </strong>
                                                </p>
                                              </div>

                                              <div className="col-xs-11 col-sm-11 col-md-11">
                                                <div
                                                  dangerouslySetInnerHTML={{ __html: data.q_text_hindi }}
                                                  style={{
                                                    margin: '15px !important',
                                                    padding: '0 !important',
                                                    lineHeight: '1.2 !important',
                                                    display: 'block',
                                                    width: '100%',
                                                    marginBottom: '0 !important',
                                                    border: 'none !important',
                                                    outline: 'none !important',
                                                    fontFamily: 'Verdana, Geneva, Tahoma, sans-serif',
                                                  }}
                                                  className={`${styles.paperFontSize1}`}
                                                />
                                                {renderOptions(data, "hindi")}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </React.Fragment>
                                  ))}
                                </React.Fragment>
                              );
                            })}
                          </React.Fragment>
                        ))}

                      </>
                    )}

                    {searchParams.get("key") == 1 && (
                      <>
                        {subjectArr?.map((sub) => {
                          return (
                            <React.Fragment key={uid(sub)}>

                              {sectionArr?.map((sec, secIndex) => {
                                const sec_inst_cond = !isEmpty(foramtData.find(x => (x.section_id == sec.sec_id && x.sub_id == sub.sub_id))?.section_instruction)
                                const questions = quesData?.filter(
                                  (x) =>
                                  (x.sub_id == sub.sub_id &&
                                    x.sec_id == sec.sec_id)
                                );
                                // Group questions by paragraph_id
                                const seqMap = {}; questions.forEach((q, i) => { seqMap[q.matrix_id] = i + 1; });
                                const grouped = {};
                                questions.forEach(q => {
                                  const pid = q.paragraph_id || `no_para_${q.matrix_id}`;
                                  if (!grouped[pid]) grouped[pid] = [];
                                  grouped[pid].push(q);
                                });
                                return !isEmpty(questions) && (
                                  <React.Fragment key={uid(sec)}>
                                    <div className={styles.tableTitle} style={{ pageBreakBefore: sec_inst_cond ? 'always' : "none", borderBottom: sec_inst_cond ? 'none' : "2px solid #000", marginBottom: sec_inst_cond ? "0" : "10px" }}>
                                      <span>
                                        {sub.subject?.toUpperCase()}
                                      </span>
                                      <hr />
                                    </div>
                                    {sec_inst_cond && (
                                      <div className={styles.instruction1}>
                                        <img src={getInstructionImageUrl(foramtData?.find(x => (x.section_id == sec.sec_id && x.sub_id == sub.sub_id))?.section_instruction)} style={{ width: "100%" }} alt={sub.subject + " " + sec.section_name} />
                                      </div>
                                    )}
                                    <div style={{ columnCount: 2, gap: '61px' }} className={styles.paperFontSize}>

                                      {Object.values(grouped).map((group, gidx) => (
                                        <React.Fragment key={gidx}>
                                          {/* Render passage only once per group */}
                                          {(!isEmpty(group[0].p_text) || !isEmpty(group[0].m_p_text)) && (
                                            <div className="col-xs-12 col-sm-12 col-md-12">
                                              <b>Passage:</b>
                                              <div dangerouslySetInnerHTML={{ __html: group[0].p_text || group[0].m_p_text }} className={styles.paperFontSize} />
                                            </div>
                                          )}
                                          {group.map((data, index) => (
                                            <div className="col-xs-12 col-sm-12 col-md-12 mb-3" style={{ pageBreakInside: "avoid" }} key={data.matrix_id}>
                                              <div className="row">
                                                <div className="col-xs-1 col-sm-1 col-md-1 q-font">
                                                  <p>
                                                    <strong>
                                                      {
                                                        info.number_sequence === 1
                                                          ? data.display_number
                                                          : info.number_sequence === 2
                                                            ? seqMap[data.matrix_id]
                                                            : info.number_sequence === 3
                                                              ? (subjectWiseSeqMap[data.matrix_id] ?? data.display_number)
                                                              : data.display_number
                                                      }.
                                                    </strong>
                                                  </p>
                                                </div>

                                                <div className="col-xs-11 col-sm-11 col-md-11 mt-1">
                                                  <div
                                                    dangerouslySetInnerHTML={{
                                                      __html: data.q_text,
                                                    }}
                                                    className={styles.paperFontSize}
                                                  />
                                                  {renderOptions(data, "english")}
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </React.Fragment>
                                      ))}

                                    </div>
                                  </React.Fragment>
                                );
                              })}
                            </React.Fragment>
                          );
                        })}

                      </>
                    )}
                    {searchParams.get("key") == 2 && (
                      <>
                        {subjectArr.map((sub) => {
                          return (
                            <React.Fragment key={uid(sub)}>

                              {sectionArr.map((sec, secIndex) => {
                                const sec_inst_cond = !isEmpty(foramtData.find(x => (x.section_id == sec.sec_id && x.sub_id == sub.sub_id))?.section_instruction)
                                const questions = quesData?.filter(
                                  (x) =>
                                  (x.sub_id == sub.sub_id &&
                                    x.sec_id == sec.sec_id)
                                );
                                // Group questions by paragraph_id
                                const seqMap = {}; questions.forEach((q, i) => { seqMap[q.matrix_id] = i + 1; });
                                const grouped = {};
                                questions.forEach(q => {
                                  const pid = q.paragraph_id || `no_para_${q.matrix_id}`;
                                  if (!grouped[pid]) grouped[pid] = [];
                                  grouped[pid].push(q);
                                });
                                return !isEmpty(questions) && (
                                  <React.Fragment key={uid(sec)}>
                                    <div className={styles.tableTitle} style={{ pageBreakBefore: sec_inst_cond ? 'always' : "none", borderBottom: sec_inst_cond ? 'none' : "2px solid #000", marginBottom: sec_inst_cond ? "0" : "10px" }}>
                                      <span>
                                        {sub.subject?.toUpperCase()}
                                      </span>
                                    </div>
                                    <hr />
                                    {sec_inst_cond && (
                                      <div className={styles.instruction1}>
                                        <img src={getInstructionImageUrl(foramtData?.find(x => (x.section_id == sec.sec_id && x.sub_id == sub.sub_id))?.section_instruction)} style={{ width: "100%" }} alt={sub.subject + " " + sec.section_name} />
                                      </div>
                                    )}
                                    <div style={{ columnCount: 2 }}>

                                      {Object.values(grouped).map((group, gidx) => (
                                        <React.Fragment key={gidx}>
                                          {/* Render passage only once per group */}
                                          {(!isEmpty(group[0].p_text) || !isEmpty(group[0].m_p_text)) && (
                                            <div className="col-xs-12 col-sm-12 col-md-12 mb-3">
                                              <b>Passage:</b>
                                              <div dangerouslySetInnerHTML={{ __html: group[0].p_text_hindi || group[0].m_p_text_hindi }} className={styles.paperFontSize} />
                                            </div>
                                          )}
                                          {group.map((data, quesIndex) => (
                                            <div className="col-xs-12 col-sm-12 col-md-12 mb-3" style={{ pageBreakInside: "avoid" }} key={data.matrix_id}>
                                              <div className="row">
                                                <div className="col-xs-1 col-sm-1 col-md-1 q-font">
                                                  <p>
                                                    <strong>
                                                      {
                                                        info.number_sequence === 1
                                                          ? data.display_number
                                                          : info.number_sequence === 2
                                                            ? seqMap[data.matrix_id]
                                                            : info.number_sequence === 3
                                                              ? (subjectWiseSeqMap[data.matrix_id] ?? data.display_number)
                                                              : data.display_number
                                                      }.
                                                    </strong>
                                                  </p>
                                                </div>

                                                <div className="col-xs-11 col-sm-11 col-md-11">
                                                  <div
                                                    dangerouslySetInnerHTML={{
                                                      __html: data.q_text_hindi,
                                                    }}
                                                    className={styles.paperFontSize}
                                                  />
                                                  {renderOptions(data, "hindi")}
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </React.Fragment>
                                      ))}



                                    </div>
                                  </React.Fragment>
                                );
                              })}
                            </React.Fragment>
                          );
                        })}

                      </>
                    )}
                    {searchParams.get("key") == 3 && (
                      <>
                        {subjectArr?.map((sub) => {
                          return (
                            <React.Fragment key={uid(sub)}>

                              {sectionArr.map((sec, secIndex) => {
                                const sec_inst_cond = !isEmpty(foramtData.find(x => (x.section_id == sec.sec_id && x.sub_id == sub.sub_id))?.section_instruction)
                                const questions = quesData?.filter(
                                  (x) =>
                                  (x.sub_id == sub.sub_id &&
                                    x.sec_id == sec.sec_id)
                                );
                                // Group questions by paragraph_id
                                const seqMap = {}; questions.forEach((q, i) => { seqMap[q.matrix_id] = i + 1; });
                                const grouped = {};
                                questions.forEach(q => {
                                  const pid = q.paragraph_id || `no_para_${q.matrix_id}`;
                                  if (!grouped[pid]) grouped[pid] = [];
                                  grouped[pid].push(q);
                                });
                                return !isEmpty(questions) && (
                                  <React.Fragment key={uid(sec)}>
                                    <div className={styles.tableTitle} style={{ pageBreakBefore: sec_inst_cond ? 'always' : "none", borderBottom: sec_inst_cond ? 'none' : "2px solid #000", marginBottom: sec_inst_cond ? "0" : "10px" }}>
                                      <span>
                                        {sec.section_name?.toUpperCase()}
                                      </span>
                                    </div>
                                    {sec_inst_cond && (
                                      <div className={styles.instruction1}>
                                        <img src={getInstructionImageUrl(foramtData.find(x => (x.section_id == sec.sec_id && x.sub_id == sub.sub_id)).section_instruction)} style={{ width: "100%" }} alt={sub.subject + " " + sec.section_name} />
                                      </div>
                                    )}
                                    <div style={{ columnCount: 2 }}>

                                      {Object.values(grouped).map((group, gidx) => (
                                        <React.Fragment key={gidx}>
                                          {/* Render passage only once per group */}
                                          {(!isEmpty(group[0].p_text) || !isEmpty(group[0].m_p_text)) && (
                                            <div className="col-xs-12 col-sm-12 col-md-12 mb-3">
                                              <b>Passage:</b>
                                              <div dangerouslySetInnerHTML={{ __html: group[0].p_text || group[0].m_p_text }} className={styles.paperFontSize} />
                                            </div>
                                          )}
                                          {group.map((data, quesIndex) => (
                                            <div className="col-xs-12 col-sm-12 col-md-12 mb-3" style={{ pageBreakInside: "avoid" }} key={data.matrix_id}>
                                              <div className="row">
                                                <div className="col-xs-1 col-sm-1 col-md-1 q-font">
                                                  <p>
                                                    <strong>
                                                      {
                                                        info.number_sequence === 1
                                                          ? data.display_number
                                                          : info.number_sequence === 2
                                                            ? seqMap[data.matrix_id]
                                                            : info.number_sequence === 3
                                                              ? (subjectWiseSeqMap[data.matrix_id] ?? data.display_number)
                                                              : data.display_number
                                                      }.
                                                    </strong>
                                                  </p>
                                                </div>

                                                <div className="col-xs-11 col-sm-11 col-md-11">
                                                  <div
                                                    dangerouslySetInnerHTML={{
                                                      __html: data.q_text_hindi,
                                                    }}
                                                    className={styles.paperFontSize}
                                                  />
                                                  {renderOptions(data, "hindi")}
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </React.Fragment>
                                      ))}


                                    </div>
                                  </React.Fragment>
                                );
                              })}
                            </React.Fragment>
                          );
                        })}

                      </>
                    )}
                    {searchParams.get("key") == 4 && (
                      <>
                        {subjectArr.map((sub) => {
                          return (
                            <React.Fragment key={uid(sub)}>

                              {sectionArr.map((sec, secIndex) => {
                                const sec_inst_cond = !isEmpty(
                                  foramtData.find(
                                    (x) => x.section_id == sec.sec_id && x.sub_id == sub.sub_id
                                  )?.section_instruction
                                );

                                const questions = quesData?.filter(
                                  (x) => x.sub_id == sub.sub_id && x.sec_id == sec.sec_id
                                );

                                // Group questions by paragraph_id
                                const seqMap = {};
                                questions.forEach((q, i) => {
                                  seqMap[q.matrix_id] = i + 1;
                                });

                                const grouped = {};
                                questions.forEach((q) => {
                                  const pid = q.paragraph_id || `no_para_${q.matrix_id}`;
                                  if (!grouped[pid]) grouped[pid] = [];
                                  grouped[pid].push(q);
                                });

                                return (
                                  !isEmpty(questions) && (
                                    <React.Fragment key={uid(sec)}>
                                      {/* Section Title */}
                                      <div
                                        className={styles.tableTitle}
                                        style={{
                                          pageBreakBefore: sec_inst_cond ? "always" : "none",
                                          borderBottom: sec_inst_cond ? "none" : "2px solid #000",
                                          marginBottom: sec_inst_cond ? "0" : "10px",
                                        }}
                                      >
                                        <span>{sub.subject?.toUpperCase()}</span>
                                      </div>
                                      <hr />
                                      {/* Section Instruction */}
                                      {sec_inst_cond && (
                                        <div className={styles.instruction1}>
                                          <img
                                            src={
                                              getInstructionImageUrl(
                                              foramtData?.find(
                                                (x) =>
                                                  x.section_id == sec.sec_id &&
                                                  x.sub_id == sub.sub_id
                                              )?.section_instruction
                                            )
                                            }
                                            style={{ width: "100%" }}
                                            alt={sub.subject + " " + sec.section_name}
                                          />
                                        </div>
                                      )}

                                      {/* Questions in Single Centered Column */}
                                      <div
                                        style={{
                                          maxWidth: "1000px", // controls width
                                          margin: "0", // centers column
                                        }}
                                      >
                                        {Object.values(grouped).map((group, gidx) => (
                                          <React.Fragment key={gidx}>
                                            {/* Render passage only once per group */}
                                            {(!isEmpty(group[0].p_text) ||
                                              !isEmpty(group[0].m_p_text)) && (
                                                <div className="col-xs-12 col-sm-12 col-md-12 mb-3">
                                                  <b>Passage:</b>
                                                  <div
                                                    dangerouslySetInnerHTML={{
                                                      __html: group[0].p_text || group[0].m_p_text,
                                                    }}
                                                  />
                                                </div>
                                              )}

                                            {/* Render questions */}
                                            {group.map((data, quesIndex) => (
                                              <div
                                                className="col-xs-12 col-sm-12 col-md-12 mb-3"
                                                style={{ pageBreakInside: "avoid" }}
                                                key={data.matrix_id}
                                              >
                                                <div className="row">
                                                  {/* Question Number */}
                                                  <div className="col-xs-1 col-sm-1 col-md-1 q-font">
                                                    <p>
                                                      <strong>
                                                        {
                                                          info.number_sequence === 1
                                                            ? data.display_number
                                                            : info.number_sequence === 2
                                                              ? seqMap[data.matrix_id]
                                                              : info.number_sequence === 3
                                                                ? (subjectWiseSeqMap[data.matrix_id] ?? data.display_number)
                                                                : data.display_number
                                                        }.
                                                      </strong>
                                                    </p>
                                                  </div>

                                                  {/* Question Text + Options */}
                                                  <div className="col-xs-11 col-sm-11 col-md-11">
                                                    <div
                                                      dangerouslySetInnerHTML={{
                                                        __html: data.q_text_hindi,
                                                      }}
                                                    />
                                                    {/* {!isEmpty(data.h_option) &&
                                                      data.h_option
                                                        ?.split("@")
                                                        ?.map((option, index) => {
                                                          return (
                                                            <div
                                                              key={uid(option)}
                                                              className="col-md-12 col-sm-12 col-xs-12 d-flex gap-2 mb-1"
                                                            >
                                                              <p>{`(${String.fromCharCode(
                                                                65 + index
                                                              )})`}</p>
                                                              <div
                                                                dangerouslySetInnerHTML={{
                                                                  __html: option,
                                                                }}
                                                              />
                                                            </div>
                                                          );
                                                        })} */}
                                                  </div>
                                                </div>
                                              </div>
                                            ))}
                                          </React.Fragment>
                                        ))}
                                      </div>
                                    </React.Fragment>
                                  )
                                );
                              })}
                            </React.Fragment>
                          );
                        })}
                      </>
                    )}
                    {searchParams.get("key") == 5 && (
                      <>
                        {subjectArr.map((sub) => {
                          return (
                            <React.Fragment key={uid(sub)}>

                              {sectionArr.map((sec, secIndex) => {
                                const sec_inst_cond = !isEmpty(
                                  foramtData.find(
                                    (x) => x.section_id == sec.sec_id && x.sub_id == sub.sub_id
                                  )?.section_instruction
                                );

                                const questions = quesData?.filter(
                                  (x) => x.sub_id == sub.sub_id && x.sec_id == sec.sec_id
                                );

                                // Group questions by paragraph_id
                                const seqMap = {};
                                questions.forEach((q, i) => {
                                  seqMap[q.matrix_id] = i + 1;
                                });

                                const grouped = {};
                                questions.forEach((q) => {
                                  const pid = q.paragraph_id || `no_para_${q.matrix_id}`;
                                  if (!grouped[pid]) grouped[pid] = [];
                                  grouped[pid].push(q);
                                });

                                return (
                                  !isEmpty(questions) && (
                                    <React.Fragment key={uid(sec)}>
                                      {/* Section Title */}
                                      <div
                                        className={styles.tableTitle}
                                        style={{
                                          pageBreakBefore: sec_inst_cond ? "always" : "none",
                                          borderBottom: sec_inst_cond ? "none" : "2px solid #000",
                                          marginBottom: sec_inst_cond ? "0" : "10px",
                                        }}
                                      >
                                        <span>{sub.subject?.toUpperCase()}</span>
                                      </div>
                                      <hr />
                                      {/* Section Instruction */}
                                      {sec_inst_cond && (
                                        <div className={styles.instruction1}>
                                          <img
                                            src={
                                              getInstructionImageUrl(
                                              foramtData?.find(
                                                (x) =>
                                                  x.section_id == sec.sec_id &&
                                                  x.sub_id == sub.sub_id
                                              )?.section_instruction
                                              )
                                            }
                                            style={{ width: "100%" }}
                                            alt={sub.subject + " " + sec.section_name}
                                          />
                                        </div>
                                      )}

                                      {/* Questions in Single Centered Column */}
                                      <div
                                        style={{
                                          maxWidth: "1000px", // controls width
                                          margin: "0 ", // centers column
                                        }}
                                      >
                                        {Object.values(grouped).map((group, gidx) => (
                                          <React.Fragment key={gidx}>
                                            {/* Render passage only once per group */}
                                            {(!isEmpty(group[0].p_text) ||
                                              !isEmpty(group[0].m_p_text)) && (
                                                <div className="col-xs-12 col-sm-12 col-md-12 mb-3">
                                                  <b>Passage:</b>
                                                  <div
                                                    dangerouslySetInnerHTML={{
                                                      __html: group[0].p_text || group[0].m_p_text,
                                                    }}
                                                  />
                                                </div>
                                              )}

                                            {/* Render questions */}
                                            {group.map((data, quesIndex) => (
                                              <div
                                                className="col-xs-12 col-sm-12 col-md-12 mb-3"
                                                style={{ pageBreakInside: "avoid" }}
                                                key={data.matrix_id}
                                              >
                                                <div className="row">
                                                  {/* Question Number */}
                                                  <div className="col-xs-1 col-sm-1 col-md-1 q-font">
                                                    <p>
                                                      <strong>
                                                        {
                                                          info.number_sequence === 1
                                                            ? data.display_number
                                                            : info.number_sequence === 2
                                                              ? seqMap[data.matrix_id]
                                                              : info.number_sequence === 3
                                                                ? (subjectWiseSeqMap[data.matrix_id] ?? data.display_number)
                                                                : data.display_number
                                                        }.
                                                      </strong>
                                                    </p>
                                                  </div>

                                                  {/* Question Text + Options */}
                                                  <div className="col-xs-11 col-sm-11 col-md-11">
                                                    <div
                                                      dangerouslySetInnerHTML={{
                                                        __html: data.q_text,
                                                      }}
                                                    />
                                                    {/* {!isEmpty(data.eng_option) &&
                                                      data.eng_option
                                                        ?.split("@")
                                                        ?.map((option, index) => {
                                                          return (
                                                            <div
                                                              key={uid(option)}
                                                              className="col-md-12 col-sm-12 col-xs-12 d-flex gap-2 mb-1"
                                                            >
                                                              <p>{`(${String.fromCharCode(
                                                                65 + index
                                                              )})`}</p>
                                                              <div
                                                                dangerouslySetInnerHTML={{
                                                                  __html: option,
                                                                }}
                                                              />
                                                            </div>
                                                          );
                                                        })} */}
                                                  </div>
                                                </div>
                                              </div>
                                            ))}
                                          </React.Fragment>
                                        ))}
                                      </div>
                                    </React.Fragment>
                                  )
                                );
                              })}
                            </React.Fragment>
                          );
                        })}


                      </>
                    )}
                    {/* 6 blank rough work pages */}
                    {Array.from({ length: 6 }).map((_, index) => (
                      <React.Fragment key={`rough-${index}`}>
                        <div className={`${styles.tableTitle1} ${styles.roughPage}`}>
                          <div style={{ borderBottom: '2px solid black' }}>
                            <span >ROUGH WORK</span>
                          </div>
                        </div>
                      </React.Fragment>
                    ))}

                    {/* Final back page image – print only */}
                    <div className={styles.backPage}>
                      <img src={backImage} alt="Back Page" />
                    </div>

                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <div className={styles.footer}>

                    <img
                      src={footerImage}
                      alt="Footer"
                      style={{ width: "100%", height: "35px", }}
                    />
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </>
      )}
    </>
  );
};

export default GeneratePaper;
